<div *ngIf="showFrame">
    <q-auth-frame></q-auth-frame>
</div>
